import { IoFemale, IoMale, IoMaleFemale } from 'react-icons/io5';

import { IObjectKeys } from '@common/types';

/**
 * Default smoke duration for insurers
 */
export const DEFAULT_SMOKE_DURATION = 24;

export const PAY_OPTION_LIMITED_60 = 'limited60';
export const PAY_OPTION_REGULAR = 'regular';

export const TERM_QUOTE_STEPS = {
  INTRO: 1,
  ABOUT_USER: 2,
  LIFESTYLE_USER: 3,
  COVER_AND_DURATION: 4,
  PLANS_AVAILABLE: 5,
  PLAN_DETAILS: 6,
  PAYMENT_TERM_OPTIONS: 7,
  ADDONS: 8,
  SUMMARY: 9,
  ORDER_DETAILS: 10
};

export const TERM_FAST_QUOTE_STEPS = {
  POLICY: 1,
  ABOUT_USER: 2,
  LIFESTYLE_USER: 3,
  PLAN: 4,
  CHECKOUT: 5
};

export const getPayOptionInfo = (payOption?: string) => {
  if (payOption === 'limited5') {
    return {
      title: 'Why 5 Pay?',
      desc: 'With the way you’re spending your money right now, you can afford to pay off all your insurance obligations in the next 5 years and still save a sizeable sum. Also, if you are planning to claim tax exemptions, the 5-pay option is an absolute bargain.'
    };
  }
  if (payOption === 'limited7') {
    return {
      title: 'Why 7 Pay?',
      desc: 'With the way you’re spending your money right now, you can afford to pay off all your insurance obligations in the next 7 years and still save a sizeable sum. Also, if you are planning to claim tax exemptions, the 7-pay option is an absolute bargain.'
    };
  } else if (payOption === 'limited10') {
    return {
      title: 'Why 10 Pay?',
      desc: 'With the way you’re spending your money right now, you can afford to pay off all your insurance obligations in the next 10 years and still save a sizeable sum. Also, if you are planning to claim tax exemptions, the 10-pay option is an absolute bargain.'
    };
  } else if (payOption === 'limited12') {
    return {
      title: 'Why 12 Pay?',
      desc: 'With the way you’re spending your money right now, you can afford to pay off all your insurance obligations in the next 12 years and still save a sizeable sum. Also, if you are planning to claim tax exemptions, the 12-pay option is an absolute bargain.'
    };
  } else if (payOption === 'limited15') {
    return {
      title: 'Why 15 Pay?',
      desc: 'With the way you’re spending your money right now, you can afford to pay off all your insurance obligations in the next 15 years and still save a sizeable sum. Also, if you are planning to claim tax exemptions, the 15-pay option is an absolute bargain.'
    };
  } else if (payOption === 'limited60') {
    return {
      title: 'Why pay till retirement?',
      desc: 'Nobody can say what you’ll be making once you retire and while it’s quite possible that you’ll still have enough to pay your premiums, why take the risk? Pay until 60 i.e. until you know for sure you’ll have a steady stream of income.'
    };
  } else if (payOption === 'regular') {
    return {
      title: 'Why regular Pay',
      desc: `Pay until the policy is in force because it's the most affordable option you can get`
    };
  }
};

export const EDUCATION_OPTIONS = [
  {
    label: 'Post Graduate',
    value: 'post_graduate'
  },
  {
    label: 'Graduate',
    value: 'graduate'
  },
  // {
  //   label: 'Diploma',
  //   value: 'diploma'
  // },
  {
    label: '12th Standard',
    value: '12th'
  },
  {
    label: '10th Standard ',
    value: '10th'
  }
  // {
  //   label: 'Below 10th',
  //   value: 'below_10th'
  // }
];

export const TERM_FREQUENCY_MONTHLY = 'Monthly';
export const TERM_FREQUENCY_YEARLY = 'Yearly';
export const TERM_FREQUENCY_QUARTERLY = 'Quarterly';
export const TERM_FREQUENCY_HALF_YEARLY = 'Half-Yearly';

export const TERM_FREQUENCY_OPTIONS_LIST: {
  label: string;
  value: string;
  desc: string;
  shortLabel: string;
}[] = [
  {
    label: 'Monthly Pay',
    value: TERM_FREQUENCY_MONTHLY,
    desc: 'Pay every month',
    shortLabel: 'per month'
  },
  {
    label: 'Quarterly Pay',
    value: TERM_FREQUENCY_QUARTERLY,
    desc: 'Pay every quarter',
    shortLabel: 'per quarter'
  },
  {
    label: 'Half-Yearly Pay',
    value: TERM_FREQUENCY_HALF_YEARLY,
    desc: 'Pay every 6 months',
    shortLabel: 'for 6 months'
  },
  {
    label: 'Yearly Pay',
    value: TERM_FREQUENCY_YEARLY,
    desc: 'Pay every year',
    shortLabel: 'per year'
  }
];

// Add on short codes
export const LIFE_STAGE_BENEFIT = 'lsb';
export const TERMINAL_ILLNESS = 'ti';
export const WAIVER_OF_PREMIUM = 'wop';
export const INCOME_BENEFIT = 'ib';
export const ACCIDENTAL_DEATH = 'adhb';
export const ACCIDENTAL_COVER = 'acb';
export const CRITICAL_ILLNESS = 'ci';
export const EARLY_EXIT_OPTION = 'eeo';
export const COVER_CONTINUANCE_BENEFIT = 'ccb';
export const INSTA_PAYMENT = 'ip';
export const SMART_EXIT_BENEFIT = 'seb';
export const ADDITIONAL_SMART_EXIT_BENEFIT = 'aseb';
export const IMMEDIATE_PAYOUT_ON_INTIMATION = 'ipci';
export const HEALTH_MANAGEMENT_SERVICE = 'hms';
export const ACCIDENTAL_TOTAL_PERMANENT_DISABILITY = 'atpd';

export const TERM_PRODUCTS_SLUGS: IObjectKeys = {
  I_PROTECT_SMART: 'icici',
  I_PROTECT_SMART_PLUS: 'iciciplus',
  // SMART_SECURE_PLUS: 'maxlife',
  CLICK_2_PROTECT_SUPER: 'hdfcc2ps',
  CLICK_2_PROTECT_SUPREME: 'hdfcc2psn',
  CLICK_2_PROTECT_SUPREME_PLUS: 'hdfcc2psp',
  SMART_TOTAL_ELITE: 'maxlifestep',
  E_TOUCH: 'e-touch',
  SMART_TERM_PLAN_PLUS: 'maxlifestpp'
};

export const TERM_QUOTE_SLUGS = {
  about: 'about',
  lifestyle: 'lifestyle',
  suggestion: 'suggestion',
  plans: 'plans',
  policy: 'policy',
  payoptions: 'payoptions',
  addons: 'addons',
  summary: 'summary',
  order: 'order',
  plan: 'plan',
  checkout: 'checkout'
};

export const ACI = 'ACI';
export const CCI = 'COMPREHENSIVE';

export const DEF_PINCODE_INFO = `The communication address is where you reside currently. It's where the insurer will conduct your medicals. Also do note that Maxlife doesn't service a few pincodes due to Covid related restrictions.`;

export const PREMIUM_OVERLAP_MSG =
  'The sum of premiums for your riders exceed the premium for your base term plan. Please reduce the sum assured for the included riders or remove other riders to proceed!';
export const PREMIUM_OVERLAP_TITLE = 'Cannot include add-on';

export const PREMIUM_OVERFLOW_MSG =
  'The premium for the rider exceed the premium for your base term plan. Please reduce the sum insured in order to include the rider';
export const PREMIUM_OVERFLOW_TITLE = 'Cannot include add-on';

export const PREMIUM_OVERLAP_HDFC_LIFE_ERROR =
  'Total rider premiums should not exceed the base premiums';

export const PREMIUM_OVERLAP_MAX_LIFE_ERROR =
  'Total rider premiums should not exceed the base premiums';

export const PREMIUM_OVERLAP_ICICI_ERROR =
  'Total rider premiums should not exceed the base premiums';

export const INDIA = 'India';

export const MALE = 'Male';
export const FEMALE = 'Female';
export const OTHERS = 'Transgender';

export const GENDER_OPTIONS = [
  {
    label: MALE,
    value: MALE,
    icon: <IoMale />
  },
  {
    label: FEMALE,
    value: FEMALE,
    icon: <IoFemale />
  }
];

export const GENDER_OPTIONS_WITH_OTHERS = [
  ...GENDER_OPTIONS,
  {
    label: 'Others',
    value: OTHERS,
    icon: <IoMaleFemale />
  }
];

export const BOOLEAN_OPTIONS = [
  {
    label: 'Yes',
    value: true
  },
  {
    label: 'No',
    value: false
  }
];

export const TERM_FAST_QUOTE_ABOUT_FORM_ID = 'term-fast-quote-about-form';
export const TERM_FAST_QUOTE_LIFESTYLE_FORM_ID = 'term-fast-quote-lifestyle-form';
export const TERM_FAST_QUOTE_PLAN_FORM_ID = 'term-fast-quote-plan-form';
